// extracted by mini-css-extract-plugin
export default {"allow":"Allow_allow__lxRar","containerField":"Allow_containerField__cP-Mm"};